export default {
  share: {
    title: "Compartir Horarios",
    selectStaff: "Seleccionar Secretaria o Institución",
    selectStaffPlaceholder: "Elige una secretaria o institución...",
    searchStaff: "Buscar por nombre o email...",
    teamSecretaries: "Secretarias del equipo",
    addTeamSecretaries: "Agregar secretarias al equipo",
    institutions: "Instituciones",
    availableSchedules: "Horarios Disponibles",
    noSchedules: "No tienes horarios configurados.",
    configureSchedules: "Configura tus horarios primero",
    slotDuration: "turnos de {{minutes}} min",
    alreadyShared: "Ya compartido",
    shareSelected: "Compartir Horarios Seleccionados",
    sharedWith: "Horarios Compartidos con",
    noSharedYet: "Aún no has compartido horarios con nadie.",
    confirmRemove: "¿Estás seguro de que quieres dejar de compartir este horario?",
    infoTitle: "Información Importante",
    infoBody:
      "Al compartir horarios, las secretarias e instituciones seleccionadas podrán ver y gestionar esos horarios para asignar turnos. Solo se comparten los horarios que selecciones.",
    infoSecretariesTitle: "¿Qué pueden hacer las secretarias?",
    infoSecretaries1: "Ver solo los horarios que les has compartido",
    infoSecretaries2: "Asignar turnos en esos slots disponibles",
    infoSecretaries3:
      "No pueden ver turnos particulares o de obra social existentes",
    infoSecretaries4: "No pueden superponer turnos ya programados",
    infoAccessTitle: "Control de acceso",
    infoAccess1: "Puedes revocar el acceso en cualquier momento",
    infoAccess2: "Los turnos ya asignados se mantienen",
    infoAccess3: "Las secretarias solo ven información básica",
    infoAccess4: "Tú mantienes el control total de tu agenda",
    groupedHint: "Agrupado por persona; dentro de cada uno, por día y horario.",
    toastSelectSchedule: "Selecciona al menos un horario para compartir",
    toastSelectSecretary: "Selecciona una secretaria",
    toastShared: "Horarios compartidos exitosamente",
    toastRemoved: "Horario eliminado de compartidos exitosamente",
  },
  gate: {
    title: "Validación pendiente",
    body: "Tu cuenta profesional aún no está habilitada para operar. Completá tus datos en Settings y subí fotos del DNI frente y dorso para que administración pueda validarte.",
    goSettings: "Ir a Settings",
    goHome: "Ir al menú principal",
  },
  admin: {
    title: "Panel de administración",
    back: "Volver al inicio",
    professionals: "Profesionales",
    whitelist: "Lista blanca",
    email: "Email",
    name: "Nombre",
    enabled: "Habilitado",
    actions: "Acciones",
    viewDni: "Ver DNI",
    addEmail: "Agregar email",
    whitelistHelp:
      "Emails autorizados para registrarse como profesional. El email debe coincidir exactamente (sin importar mayúsculas).",
    toastInvalidEmail: "Ingresá un email válido.",
    toastEmailAdded: "Email agregado a la lista.",
    toastEmailRemoved: "Email quitado de la lista.",
    toastUpdateError: "No se pudo actualizar",
    toastEnabled: "Profesional habilitado",
    toastDisabled: "Profesional deshabilitado",
    notUploaded: "Sin cargar",
    noFrontPhoto: "Sin foto de frente.",
    noBackPhoto: "Sin foto de dorso.",
    license: "Matrícula",
    specialty: "Especialidad",
    phone: "Teléfono",
    operates: "Opera",
    emailPlaceholder: "correo@ejemplo.com",
  },
  register: {
    emailRequired: "El email es obligatorio",
    emailInvalid: "El email no es válido",
    nameRequired: "El nombre es obligatorio",
    lastNameRequired: "El apellido es obligatorio",
    phoneRequired: "El teléfono es obligatorio",
    passwordMin: "La contraseña debe tener al menos 6 caracteres",
    passwordMismatch: "Las contraseñas no coinciden",
    termsRequired: "Debes aceptar los términos y condiciones para continuar",
    specializationRequired: "La especialización es obligatoria para médicos",
    licenseRequired: "La matrícula es obligatoria para profesionales",
    orgNameRequired: "El nombre del hospital/institución/asociación es obligatorio",
    createError: "Error al crear el usuario. Intente nuevamente.",
    registrationNotAllowed:
      "Próximamente podrás utilizar este mail para registrarte en nuestra plataforma",
    successProfessional:
      "¡Cuenta de profesional creada exitosamente! Te redirigimos al menú principal...",
    successManualLogin:
      "Cuenta creada exitosamente. Por favor, inicia sesión manualmente.",
    emailExists: "Este email ya está registrado. Intenta iniciar sesión.",
    invalidEmailFormat: "El formato del email no es válido.",
    successRole: "¡Cuenta de {{role}} creada exitosamente! Iniciando sesión...",
    personalInfo: "Información Personal",
    basicInfo: "Información básica",
    yourName: "Tu nombre",
    yourLastName: "Tu apellido",
    specializationPlaceholder: "Ej: Cardiología, Pediatría, Medicina General",
    licensePlaceholder: "Ej: MN 123456",
    associationInfo: "Información de la Asociación",
    institutionInfo: "Información Institucional",
    associationName: "Nombre de la Asociación *",
    hospitalName: "Nombre del Hospital/Clínica *",
    orgPlaceholder: "Ej: Hospital Central, Clínica San José",
    passwordPlaceholder: "Mínimo 6 caracteres",
    confirmPasswordPlaceholder: "Repetir contraseña",
    institutionLabel: "Institución",
    genericError: "Error al registrarse. Intente nuevamente.",
    roleDoctor: "Profesional médico independiente",
    roleInstitution: "Hospital, clínica o centro médico",
    roleAssociation: "Asociación médica o profesional",
    roleSecretary: "Secretaria de una institución médica",
    rolePatient: "Persona que busca atención médica",
    roleDoctorShort: "médico",
    roleInstitutionShort: "institución",
    roleAssociationShort: "asociación",
    roleSecretaryShort: "secretaria",
    rolePatientShort: "paciente",
    firstName: "Nombre *",
    lastName: "Apellido *",
    phone: "Teléfono *",
    password: "Contraseña *",
    confirmPassword: "Confirmar contraseña *",
    acceptTerms: "Acepto los términos y condiciones",
    acceptTermsPrefix: "Acepto los",
    termsLink: "términos y condiciones",
    consentMarketing:
      "Acepto recibir mensajes de texto y/o correos electrónicos",
    creatingAccount: "Creando cuenta...",
    createAccountAs: "Crear cuenta como {{role}}",
    roleInstitutionLabel: "Institución",
    submit: "Registrarse",
    hasAccount: "¿Ya tenés cuenta?",
    loginLink: "Iniciá sesión",
    accountType: "Tipo de cuenta *",
    rolePatientLabel: "Paciente",
    roleDoctorLabel: "Médico",
    roleAssociationLabel: "Asociación",
    roleSecretaryLabel: "Secretaria",
    professionalInfo: "Información Profesional",
    specialization: "Especialización *",
    licenseNumber: "Número de matrícula *",
    security: "Seguridad",
    termsSection: "Términos y Consentimiento",
    termsTitle: "Términos y Condiciones",
    termsLegal: {
      acceptanceTitle: "1. Aceptación de los Términos",
      acceptanceBody:
        "Al acceder y utilizar esta plataforma, usted acepta estar sujeto a estos términos y condiciones de uso. Si no está de acuerdo con alguna parte de estos términos, no debe utilizar nuestros servicios.",
      serviceTitle: "2. Uso del Servicio",
      serviceBody:
        "Usted se compromete a utilizar la plataforma únicamente para fines legales y de acuerdo con estos términos. No debe utilizar el servicio de manera que pueda dañar, deshabilitar, sobrecargar o comprometer nuestros sistemas.",
      accountTitle: "3. Cuenta de Usuario",
      accountBody:
        "Es responsable de mantener la confidencialidad de su cuenta y contraseña. Usted acepta la responsabilidad de todas las actividades que ocurran bajo su cuenta. Debe notificarnos inmediatamente de cualquier uso no autorizado de su cuenta.",
      privacyTitle: "4. Privacidad y Protección de Datos",
      privacyBody:
        "Respetamos su privacidad y protegemos sus datos personales de acuerdo con nuestra política de privacidad. Al utilizar nuestros servicios, usted consiente la recopilación y el uso de información de acuerdo con dicha política.",
      responsibilitiesTitle: "5. Responsabilidades del Usuario",
      responsibilitiesBody:
        "Usted es responsable de proporcionar información precisa y actualizada. No debe proporcionar información falsa, engañosa o fraudulenta. Cualquier violación de estos términos puede resultar en la terminación inmediata de su cuenta.",
      liabilityTitle: "6. Limitación de Responsabilidad",
      liabilityBody:
        "En la medida máxima permitida por la ley, no seremos responsables de ningún daño directo, indirecto, incidental, especial o consecuente que resulte del uso o la imposibilidad de usar nuestros servicios.",
      modificationsTitle: "7. Modificaciones de los Términos",
      modificationsBody:
        "Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación. Su uso continuado del servicio después de dichas modificaciones constituye su aceptación de los nuevos términos.",
      contactTitle: "8. Contacto",
      contactBody:
        "Si tiene alguna pregunta sobre estos términos y condiciones, puede contactarnos a través de los medios proporcionados en nuestra plataforma.",
    },
    email: "Email *",
    emailPlaceholder: "tu@email.com",
    phonePlaceholderExample: "+54 11 1234-5678",
  },
  appointments: {
    assigning: "Asignando turno…",
    booking: "Reservando turno…",
    selectDate: "Seleccionar Fecha",
    patientData: "Datos del Paciente",
    forPatient: "Para: {{name}}",
    restrictedAccess: "Acceso Restringido",
    restrictedAccessLower: "Acceso restringido",
    fillRequired: "Por favor completa todos los campos requeridos (incluido el motivo)",
    bookSuccess: "Turno reservado exitosamente",
    bookError: "Error al reservar el turno. Intenta nuevamente.",
    assignError: "Error al asignar el turno. Intente nuevamente.",
    noSlots: "No hay horarios disponibles para asignar.",
    noSlotsLeftToday: "No quedan horarios para hoy",
    noSlotsForDate: "No hay horarios para esta fecha",
    slotInPast: "Ese horario ya pasó. Elegí uno a partir de la hora actual.",
    searchEmail: "Por favor ingresa un email para buscar",
    searchError: "Error al buscar el paciente. Intente nuevamente.",
    inviteEmail: "Por favor ingresa un email para enviar la invitación",
    inviteInvalidEmail: "Por favor ingresa un email válido",
    inviteSuccess: "Invitación enviada exitosamente por email",
    inviteError: "Error al enviar la invitación. Intente nuevamente.",
    myAppointments: "Todos mis Turnos",
    assignedHistory: "Historial de Turnos Asignados",
    updateError: "Error al actualizar el turno",
    cancelError: "Error al cancelar el turno",
    next7Days: "Próximos 7 días",
    totalSeen: "Total Atendidos",
    schedulesConfigured: "Horarios Config.",
    upcoming: "Próximos Turnos",
    available: "Disponible",
    notes: "Notas:",
    reason: "Motivo:",
    dateTime: "Fecha y hora:",
    confirmCancel: "¿Estás seguro de que deseas cancelar el turno de {{name}}?",
    confirmCancelGeneric: "¿Estás seguro que deseas cancelar?",
    confirmCancelDesc: "Esta acción liberará el horario para otros pacientes.",
    confirmYes: "Sí, cancelar",
    cancelAppointment: "Cancelar turno",
    cancelSuccess: "Turno cancelado correctamente",
    cancelDaysTitle: "Cancelar día/s",
    enableCancellation: "Habilitar cancelación",
    cancellationOn: "Activado",
    cancellationOff: "Desactivado",
    cancellationEnabledHint: "Seleccioná los días en el calendario superior",
    cancellationDisabledHint: "Activá el switch para cancelar uno o más días",
    selectDaysLegend: "Elige los días a cancelar en el calendario de arriba",
    cancellationReason: "Motivo",
    cancellationReasonPlaceholder: "Ej: urgencia médica, vacaciones, etc.",
    notifyPatients: "Avisar a mis pacientes",
    notifyPatientsHint: "Se les notificará a tus pacientes vía email",
    reasonRequired: "Debés ingresar un motivo de cancelación",
    selectDatesRequired: "Debés seleccionar al menos un día",
    noAppointmentsToCancel: "No hay turnos tomados en los días seleccionados",
    bulkCancelSuccess: "Turnos cancelados y pacientes notificados",
    bulkCancelConfirmDesc: "Se cancelarán {{count}} turno(s) y se enviará un email a cada paciente afectado.",
    selectedDaysCount: "{{count}} día(s) seleccionado(s) — {{appointments}} turno(s) afectado(s)",
    cancelFromEmailTitle: "Cancelar turno",
    cancelFromEmailDesc: "Estás por cancelar el siguiente turno:",
    invalidCancelLink: "El enlace de cancelación no es válido.",
    alreadyCancelled: "Este turno ya fue cancelado o no puede modificarse.",
    slotTaken:
      "Este horario ya está ocupado. Por favor selecciona otro horario disponible.",
    patientSlotTaken: "Ya tenés un turno reservado en este horario.",
    noScheduled: "No tenés turnos agendados.",
    doctorsOnly: "Esta sección es solo para médicos.",
    assignRolesOnly:
      "Solo médicos, secretarias e instituciones pueden asignar turnos.",
    doctorPageTitle: "Mis Turnos",
    doctorPageSubtitle: "Revisa todos tus turnos programados y disponibilidad",
    patientPageSubtitle: "Revisa tus citas médicas programadas e historial",
    today: "Hoy",
    totalAppointmentsLabel: "Total de Turnos",
    completedLabel: "Completados",
    createdOn: "Creado el",
    unknownDoctor: "Médico Desconocido",
    noUpcomingScheduled: "No tienes turnos programados",
    scheduledCount: "{{count}} turnos programados",
    noDaySchedule: "No tienes horarios configurados para este día",
    patientFallback: "Paciente",
    defaultPatientName: "este paciente",
    appointmentNotFound: "No se encontró el turno a cancelar",
    doctorNotAvailable: "Este profesional no está disponible para recibir turnos.",
    unregisteredPatientHistory:
      "Este paciente no está registrado en el sistema. No se puede crear una historia clínica para pacientes no registrados.",
    viewMoreAppointments: "Ver Más Turnos",
    bookAppointment: "Reservar Turno",
    bookFirstAppointment: "Reservar tu Primer Turno",
    noRegisteredAppointments: "No tienes turnos registrados",
    recentHistory: "Historial Reciente",
    noAppointmentHistory: "No tienes historial de turnos",
    hospital: "Hospital",
    statusOccupied: "Ocupado",
    statusAvailable: "Libre",
    statusCompleted: "Completado",
    statusCancelled: "Cancelado",
    statusUnknown: "Sin estado",
    assignedBySecretary: "Asignado por {{name}}",
    statusConfirmed: "Confirmado",
    secretaryFallback: "Secretaria",
  },
  scheduleConfig: {
    addTitle: "Agregar Nuevo Horario",
    configuredTitle: "Horarios Configurados",
    selectDay: "Selecciona al menos un día",
    selectDate: "Selecciona al menos una fecha en el calendario",
    addedSuccess: "Horarios agregados exitosamente",
    blockedSuccess: "Días bloqueados correctamente",
    occasionalAdded: "Horario ocasional agregado",
    configureLink: "Configurar Horarios",
    blockReason: "Motivo del bloqueo",
    blockReasonPlaceholder: "Ej. Feriado, Vacaciones, Congreso...",
    confirmDelete: "¿Confirmas que deseas eliminar el horario seleccionado?",
    pageTitle: "Configuración de Horarios",
    pageSubtitle: "Define tus horarios de atención, fechas especiales y días sin turnos",
    blockError: "Error al bloquear fechas",
    occasionalError: "Error al agregar horario ocasional",
    appointmentType: "Tipo de consulta",
    startTime: "Hora de inicio",
    endTime: "Hora de fin",
    slotDurationLabel: "Duración del turno (minutos)",
    blockDates: "Bloquear fechas",
    addSchedule: "Agregar Horario",
    configuredHint: "Habitual por día; ocasionales y bloqueos por fechas.",
    noSchedulesYet: "No tienes horarios configurados aún",
    habitualSchedules: "Horarios habituales",
    occasionalSchedules: "Horarios ocasionales",
    blockedDays: "Días bloqueados",
    dateCount: "{{count}} fecha",
    datesCount: "{{count}} fechas",
    scheduleCount: "{{count}} horario",
    schedulesCount: "{{count}} horarios",
    slotsOfMinutes: "(turnos de {{minutes}} min)",
    duration15: "15 minutos",
    duration30: "30 minutos",
    duration45: "45 minutos",
    duration60: "1 hora",
    duration90: "1.5 horas",
    duration120: "2 horas",
    startBeforeEnd: "La hora de inicio debe ser menor que la hora de fin",
    blockReasonRequired: "Indica el motivo del bloqueo (ej. Feriado, Vacaciones)",
    typeHabitualHint: "Horario recurrente por día de la semana (como hasta ahora).",
    typeOccasionalHint: "Atención solo en fechas puntuales del año que elijas.",
    typeBlockedHint: "Sin turnos en esas fechas (feriados, vacaciones, congresos, etc.).",
    billingLinkHint: "Para emitir facturas electrónicas necesitás configurar AFIP.",
    configureBilling: "Configurar facturación",
    shareSecretaryHint:
      "No olvides compartir tus horarios con tu secretaria, para que pueda gestionar tu agenda.",
    shareSchedulesLink: "Compartir horarios",
    scheduleTypeLabel: "Tipo de horario",
    daysOfWeekLabel: "Días de la semana",
    addSomeSchedulesError: "Error al agregar algunos horarios:\n\n{{errors}}",
  },
  clinical: {
    backToSearch: "Volver a Búsqueda",
    patientNotFoundTitle: "Paciente no encontrado",
    patientNotFoundDesc:
      "No se encontró la historia clínica de este paciente. Puede que no esté registrado en el sistema.",
    restrictedAccess: "Acceso Restringido",
    notesRequired: "Por favor, ingresa las notas de la consulta",
    saveSuccess: "Historia clínica guardada exitosamente",
    saveError: "Error al guardar la historia clínica: {{message}}",
    uploadError: "Error al subir las imágenes: {{message}}",
    noEdit: "Las historias clínicas no se pueden editar. Solo se pueden crear nuevas.",
    searchResults: "Resultados de Búsqueda",
    consultationNotes: "Notas de la Consulta",
    studySaved: "Estudio guardado correctamente",
    studyDeleted: "Estudio eliminado",
    commentUpdated: "Comentario actualizado",
    selectImage: "Seleccioná un archivo de imagen",
    imageTooLarge8: "La imagen no puede superar los 8 MB",
    chooseImage: "Elegí una imagen para subir",
    notesPlaceholder: "Describe los síntomas, diagnóstico, tratamiento recomendado, observaciones, etc.",
    attachmentsOptional: "Imágenes Adjuntas (Opcional)",
    selectedImages: "Imágenes seleccionadas:",
    searchPatient: "Buscar por email, DNI, nombre o apellido...",
    viewHistory: "Ver Historia",
    loadingHistory: "Cargando historia clínica...",
    historyTitle: "Historia Clínica",
    nameLabel: "Nombre",
    patientInfo: "Información del paciente",
    consultationDetails: "Detalles de la Consulta",
    patientLabel: "Paciente:",
    patientNotFound: "No encontrado",
    digitizationDate: "Fecha de digitalización:",
    notesHint: "Incluye toda la información relevante de la consulta médica.",
    viewPatientBackground: "Ver antecedentes del paciente",
    patientBackgroundTitle: "Antecedentes del Paciente",
    patientInfoOf: "Información de {{name}}",
    dni: "DNI",
    healthInsurance: "Obra Social / Prepaga",
    affiliateNumber: "Número de Afiliado",
    plan: "Plan",
    emergencyContact: "Contacto de emergencia",
    informedConsentSubtitle: "Consentimiento Informado",
    dateUnavailable: "Fecha no disponible",
    loadingPatient: "Cargando información del paciente...",
    newHistoryTitle: "Nueva Historia Clínica",
    saveHistory: "Guardar Historia Clínica",
    uploadHint: "Arrastra imágenes aquí o haz clic para seleccionar",
    digitizeButton: "Digitalizar Historias",
    digitizeTitle: "Digitalizar Historias",
    digitizeDetails: "Digitalización de registro físico",
    digitizeNotes: "Notas (opcional)",
    digitizeNotesPlaceholder: "Descripción opcional del registro físico (ej.: páginas digitalizadas, observaciones generales, etc.)",
    digitizeNotesHint: "Podés agregar una descripción breve. Las fotos o escaneos del registro físico son lo principal.",
    digitizeImages: "Imágenes del registro físico *",
    digitizeUploadHint: "Fotografiá o escaneá las páginas de la historia clínica física y subilas acá",
    digitizeImagesRequired: "Subí al menos una imagen del registro físico",
    digitizeDefaultNotes: "Registro físico digitalizado",
    digitizeSave: "Guardar digitalización",
    recordDate: "Fecha del registro:",
  },
  healthHistory: {
    title: "Evolución de datos de salud",
    titleOf: "Evolución de {{name}}",
    viewEvolution: "Ver evolución",
    loadError: "No se pudo cargar el historial de salud.",
    empty: "Todavía no hay registros históricos. Se guardan automáticamente cuando el paciente actualiza sus datos de salud.",
    bmi: "IMC",
    weightEvolution: "Evolución de peso:",
    date: "Fecha",
    habits: "Hábitos",
    noChange: "sin cambio",
  },
  profile: {
    officeAddress: "Dirección del consultorio",
    officeAddressHint:
      "Se muestra a los pacientes en la búsqueda junto con la distancia desde su domicilio.",
    settingsTitle: "Settings",
    tabInfo: "Información",
    tabStudies: "Mis Estudios",
    tabDependents: "Familiares",
    tabPatientData: "Mi salud",
    patientDataTitle: "Mis datos de salud",
    patientDataIntro:
      "Estos datos son los que ve el profesional que te atiende cuando sacás un turno como paciente. No se muestran en tu perfil público.",
    saved: "Datos guardados",
    saveError: "No se pudieron guardar los datos",
    tabSubscription: "Suscripción",
    tabTeam: "Equipo",
    tabBilling: "Facturacion",
    tabConfig: "Configuración",
    bookingHorizonTitle: "Visualización de turnos",
    bookingHorizonIntro: "Definí con cuánta anticipación tus pacientes pueden reservar turnos en la agenda.",
    bookingHorizonLabel: "Anticipación máxima para reservar (pacientes)",
    bookingHorizonOption: "{{days}} días",
    bookingHorizonHint: "Los pacientes solo verán fechas disponibles dentro de este rango al reservar un turno.",
    configSaved: "Configuración guardada",
    configSaveError: "Error al guardar la configuración",
    changePassword: "Cambiar contraseña",
    fileTooLarge: "El archivo no puede superar los 5 MB",
    preferences: "Preferencias",
    receiveNotifications: "Recibir notificaciones",
    passwordPlaceholder: "••••••••",
    teamTitle: "Equipo",
    required: "* Obligatorio",
    select: "Seleccionar",
    yes: "Sí",
    no: "No",
    years: "años",
    name: "Nombre",
    lastName: "Apellido",
    email: "Email",
    phone: "Teléfono",
    phoneOptional: "Teléfono (opcional)",
    contact: "Contacto",
    address: "Dirección",
    street: "Calle y número",
    floor: "Piso",
    apt: "Depto",
    city: "Localidad",
    province: "Provincia",
    postalCode: "Código Postal",
    personalData: "Datos personales",
    dni: "DNI",
    birthDate: "Fecha de nacimiento",
    gender: "Género",
    age: "Edad",
    genderMale: "Masculino",
    genderFemale: "Femenino",
    genderOther: "Otro",
    genderPreferNot: "Prefiero no decir",
    phonePatientHint: "Se usa en tus turnos y para que el equipo médico te contacte. Podés incluir código de país.",
    phoneDoctorHint: "Este número se muestra en la búsqueda y al reservar turnos contigo.",
    phoneInstitutionHint: "Este número se muestra en la página pública de la institución.",
    phoneAssociationHint: "Este número se muestra en la página pública de la asociación. El email se edita arriba junto con nombre y apellido.",
    healthInsurance: "Obra Social / Prepaga",
    healthInsuranceNumber: "Número",
    plan: "Plan",
    healthData: "Datos de salud",
    height: "Altura (cm)",
    weight: "Peso (kg)",
    phHeight: "Ej: 170",
    phWeight: "Ej: 75",
    bloodType: "Grupo sanguíneo",
    bloodFactor: "Factor",
    smoking: "Tabaquismo",
    sedentary: "Sedentarismo",
    toxics: "Tóxicos",
    antecedents: "Antecedentes",
    antecedentsPlaceholder: "Intervenciones quirúrgicas, medicación permanente u otro dato relevante para tu médico",
    disability: "Discapacidad",
    disabilityType: "Tipo",
    disabilityDetail: "Por favor detalle aquí:",
    disabilityDetailPlaceholder: "Describa su situación",
    disabilityNone: "Ninguna",
    disabilitySensory: "Sensorial (visual y auditiva)",
    disabilityPhysical: "Física",
    disabilityMental: "Mental",
    disabilityIntellectual: "Intelectual",
    emergencyContact: "Contacto de emergencia",
    emergencyOther: "Otro",
    emergencyOtherPlaceholder: "Otro medio de contacto",
    registration: "Registro",
    createdAt: "Fecha de creación:",
    updatedAt: "Última modificación:",
    professionalData: "Datos profesionales",
    abbreviation: "Abreviatura",
    specialty: "Especialidad",
    licenseNumber: "Número de Matrícula",
    identityVerification: "Verificación de identidad",
    identityHint: "Te pedimos esto para validar que realmente eres médico/a. Las imágenes son confidenciales.",
    dniFront: "Foto DNI (Frente)",
    dniBack: "Foto DNI (Dorso)",
    uploadImage: "Subir imagen",
    uploading: "Subiendo...",
    languages: "Idiomas de atención",
    languagesMax: "(máx. 4)",
    profilePhoto: "Foto de perfil",
    changePhoto: "Cambiar foto",
    profilePhotoHint: "Esta imagen se mostrará en tu perfil público.",
    institutionData: "Datos de la institución",
    associationData: "Datos de la asociación",
    fantasyName: "Nombre Fantasía",
    fantasyNameHint: "(visible para pacientes y profesionales)",
    institutionType: "Tipo de institución",
    institutionLogo: "Logo de la institución",
    associationLogo: "Logo de la asociación",
    logoFormatHint: "Formato JPG, PNG o GIF. Tamaño máximo 5 MB.",
    uploadLogo: "Subir logo",
    instConsultorio: "Consultorio",
    instPoli: "Poli Consultorio",
    instClinica: "Clínica",
    instSanatorio: "Sanatorio",
    instOtro: "Otro",
    publicDescription: "Descripción pública",
    publicDescriptionHint: "Este texto se mostrará en la página pública de la asociación, debajo de la información de contacto.",
    associatedTo: "Asociado a:",
    viewAssociation: "Ver asociación",
    passwordHint: "Dejar en blanco para no cambiar. La contraseña actual no se puede recuperar aquí por seguridad.",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar nueva contraseña",
    passwordBlankPlaceholder: "Dejar en blanco para no cambiar",
    passwordRepeatPlaceholder: "Repetir nueva contraseña",
    passwordMismatch: "Las contraseñas no coinciden",
    hidePassword: "Ocultar contraseña",
    showPassword: "Ver contraseña",
    saveChanges: "Guardar cambios",
    saving: "Guardando...",
    goHome: "Ir al inicio",
    loadError: "Hubo un error al cargar los datos del usuario:",
    teamIntro: "Invita secretarias para que administren tus turnos. Se generará una contraseña temporal que deberás compartirles. Cuando ingresen por primera vez se les solicitará cambiarla.",
    secretaryAdded: "Secretaria agregada correctamente.",
    secretaryAddError: "No se pudo agregar la secretaria.",
    secretaryRemoved: "Secretaria eliminada del equipo.",
    secretaryRemoveError: "No se pudo eliminar la secretaria.",
    tempPasswordFor: "Contraseña temporal generada para {{name}}",
    tempPasswordNew: "la nueva secretaria",
    tempPasswordShare: "Compartí esta contraseña manualmente. Al iniciar sesión deberán cambiarla para continuar.",
    passwordLabel: "Contraseña:",
    adding: "Agregando...",
    addSecretary: "Agregar secretaria",
    assignedSecretaries: "Secretarias asignadas",
    loadSecretariesError: "Error al cargar las secretarias:",
    secretaryDefault: "Secretaria",
    noSecretaries: "Todavía no agregaste secretarias. Usá el formulario superior para invitarlas a tu equipo.",
    tel: "Tel:",
    billingIntro: "Aquí puedes gestionar tu facturacion.",
    viewInvoices: "Ver Facturas",
    configureAfip: "Configurar credenciales de Afip",
    appointmentDuration: "Duración del turno",
    consultationCost: "Costo de la consulta",
    mpToken: "Token Mercado Pago",
    mpTokenTooltip: "El token de acceso es un string que identifica tu cuenta de Mercado Pago y permite autenticar las solicitudes a la API. Puedes encontrarlo en la configuración de tu cuenta de Mercado Pago, en la sección de credenciales.",
    subscriptionTitle: "Suscripción",
    subscriptionIntro: "Gestiona tu suscripción recurrente. Mantén tu cuenta activa con pagos automáticos mensuales.",
    serviceStatusLabel: "Estado del servicio",
    serviceActive: "Activa 💚",
    serviceInactive: "Inactiva 💔",
    serviceActiveHint: "Tu cuenta está habilitada en la plataforma. Podés recibir turnos y usar todas las funciones.",
    serviceInactiveHint: "Tu cuenta aún no está habilitada. Una vez confirmado el pago, el administrador activará tu servicio.",
    subscriptionLoadError: "Error al cargar la suscripción",
    subscriptionCreateError: "Error al crear la suscripción",
    paymentUrlError: "No se pudo obtener la URL de pago",
    subscriptionStatus: "Estado de la Suscripción",
    price: "Precio:",
    billingCycle: "Ciclo de facturación:",
    monthly: "Mensual",
    yearly: "Anual",
    nextBilling: "Próximo cobro:",
    lastPayment: "Último pago:",
    statusActive: "Activa",
    statusPending: "Pendiente",
    statusPaused: "Pausada",
    statusCancelled: "Cancelada",
    statusInactive: "Inactiva",
    pendingHint: "Tu suscripción está pendiente de aprobación. Completa el pago en Mercado Pago para activarla.",
    activeHint: "✓ Tu suscripción está activa. Los pagos se realizarán automáticamente según tu ciclo de facturación.",
    processing: "Procesando...",
    renewSubscription: "Renovar Suscripción",
    createSubscription: "Crear Suscripción",
    noActiveSubscription: "No tienes una suscripción activa. Crea una suscripción recurrente para mantener tu cuenta activa.",
    debitedMonthly: "Se debitará de forma mensual",
    subscribe: "Suscribirse",
    phDni: "Ej: 12345678",
    phPhone: "Ej: +54 11 1234-5678",
    phStreet: "Ej: Av. Corrientes 1234",
    phFloor: "Ej: 2",
    phApt: "Ej: A",
    phCity: "Ej: CABA",
    phProvince: "Ej: Buenos Aires",
    phPostal: "Ej: 1043",
    phInsurance: "Ej: OSDE, Swiss Medical",
    phAffiliate: "Nº afiliado",
    phPlan: "Ej: 210, 310",
    phSpecialty: "Ej: Cardiología",
    phLicense: "Ej: MN 12345",
    phInstitution: "Ej: Centro Médico San Martín",
    phAssociation: "Ej: Asociación Médica Argentina",
    phDescription: "Ej: Somos una asociación de profesionales...",
  },
  install: {
    title: "Instalar aplicación",
    subtitle: "Instala {{brand}} como aplicación",
    heroTitle: "Instala {{brand}} como aplicación",
    heroSubtitle: "Llevá la plataforma a tu escritorio o pantalla de inicio para un acceso rápido, notificaciones inmediatas y uso sin distracciones.",
    installApp: "Instalar aplicación",
    installFromBrowser: "Instalar desde el navegador",
    waitingAvailability: "Esperando disponibilidad…",
    noAutoButton: "Si tu navegador no ofrece el botón automáticamente, seguí los pasos más abajo.",
    stepsTitle: "Instalación rápida según tu dispositivo",
    stepsSubtitle: "Seguí estos pasos y en segundos vas a tener {{brand}} como una app más.",
    alreadyInstalled: "¿Ya instalaste {{brand}}?",
    alreadyInstalledHint: "Podés anclarla a tu barra de tareas o mover el ícono al lugar que te quede más cómodo. Si necesitás ayuda adicional escribinos a soporte.",
    alsoWeb: "También podés volver al inicio para seguir usando la versión web.",
    goHome: "Ir al inicio",
    badgeInstalled: "Ya está instalada en este dispositivo",
    badgeAvailable: "Instalación disponible",
    followSteps: "Seguí estos pasos y en segundos vas a tener {{brand}} como una app.",
    platformSteps: {
      ios: {
        1: "Abrí esta página en Safari.",
        2: "Tocá el botón Compartir (icono cuadrado con flecha).",
        3: "Desplazate y elegí “Agregar a pantalla de inicio”.",
        4: "Confirmá el nombre y tocá “Agregar”.",
      },
      android: {
        1: "Abrí esta página en Chrome.",
        2: "Tocá el menú ⋮ en la esquina superior derecha.",
        3: "Elegí “Agregar a pantalla principal”.",
        4: "Confirmá la acción para crear el acceso directo.",
      },
      desktop: {
        1: "En Chrome, hacé clic en el icono de instalación (monitor con flecha) a la derecha de la barra de direcciones.",
        2: "Confirmá la instalación para agregar la app al escritorio y menú inicio.",
        3: "En Edge, usá el menú ⋯ > “Aplicaciones” > “Instalar este sitio como una aplicación”.",
      },
    },
    guides: {
      chromeDesktop: {
        title: "Chrome en computadora",
        location: "Ícono de instalación a la derecha de la barra de direcciones.",
        step1: "Hacé clic en el icono Instalar app (monitor con flecha o símbolo +).",
        step2: "Cuando aparezca el modal “Instalar app”, confirmá con Instalar.",
        note: "Si no ves el icono, abrí el menú ⋮ y buscá “Instalar”.",
      },
      edgeDesktop: {
        title: "Microsoft Edge",
        location: "Menú ⋯ en la esquina superior derecha.",
        step1: "Hacé clic en ⋯ y elegí Aplicaciones.",
        step2: "Seleccioná “Instalar este sitio como una aplicación”.",
        step3: "Confirmá con Instalar.",
      },
      chromeAndroid: {
        title: "Chrome en Android",
        location: "Menú ⋮ ubicado arriba a la derecha.",
        step1: "Tocá el menú ⋮ del navegador.",
        step2: "Elegí “Instalar app” o “Agregar a pantalla principal”.",
        step3: "Confirmá con Agregar.",
      },
      safariIos: {
        title: "Safari en iPhone / iPad",
        location: "Botón Compartir (cuadrado con flecha) en la barra inferior.",
        step1: "Tocá el ícono Compartir.",
        step2: "Desplazate y elegí “Agregar a pantalla de inicio”.",
        step3: "Confirmá con Agregar.",
      },
      safariDesktop: {
        title: "Safari en macOS",
        location: "Menú “Archivo” en la barra superior.",
        step1: "En Safari, abrí el menú Archivo.",
        step2: "Seleccioná “Añadir a Dock”.",
        step3: "Confirmá y el acceso directo aparecerá en tu Dock.",
        note: "Esta opción está disponible en macOS Ventura o superior.",
      },
      firefoxAndroid: {
        title: "Firefox en Android",
        location: "Menú ⋮ en la parte superior derecha.",
        step1: "Abrí el menú ⋮.",
        step2: "Elegí “Agregar a pantalla principal”.",
        step3: "Confirmá con Agregar.",
      },
      operaAndroid: {
        title: "Opera / Samsung Internet",
        location: "Menú del navegador en la parte inferior o superior.",
        step1: "Abrí el menú del navegador.",
        step2: "Seleccioná “Agregar a pantalla principal” o “Instalar app”.",
        step3: "Confirmá la acción.",
      },
      otherAndroid: {
        title: "Otro navegador en Android",
        location: "Menú del navegador.",
        step1: "Abrí el menú del navegador.",
        step2: "Buscá la opción “Agregar a pantalla principal” o “Instalar app”.",
        step3: "Confirmá los pasos que te solicite.",
      },
      otherDesktop: {
        title: "Otro navegador en computadora",
        location: "Menú principal del navegador.",
        step1: "Buscá en el menú palabras como Instalar, Aplicación o Agregar a escritorio.",
        step2: "Seguí los pasos del navegador para confirmar la instalación.",
        note: "Algunos navegadores requieren usar Chrome o Edge para instalar la PWA.",
      },
      default: {
        title: "Instalación rápida",
        location: "Buscá en tu navegador la opción Instalar app o Agregar a pantalla de inicio.",
        step1: "Abrí el menú principal del navegador.",
        step2: "Seleccioná la opción de instalar o agregar a pantalla de inicio.",
        step3: "Confirmá cuando el navegador te lo indique.",
      },
    },
  },
  messaging: {
    title: "Envío Masivo de Mensajes",
    subtitle: "Envía mensajes por WhatsApp o Email a múltiples usuarios",
    accessRequired: "Acceso Requerido",
    sendType: "Tipo de Envío",
    messageContent: "Contenido del Mensaje",
    sentMessages: "Mensajes Enviados",
    imageTooLarge: "La imagen es demasiado grande. Máximo 5MB.",
    uploadError: "Error al subir la imagen: {{message}}",
    subject: "Asunto *",
    subjectPlaceholder: "Asunto del mensaje",
    message: "Mensaje *",
    messagePlaceholder: "Escribe tu mensaje aquí...",
    availableUsers: "Usuarios Disponibles",
    selected: "Seleccionados",
    validForSend: "Válidos para Envío",
    noContactData: "Sin Datos de Contacto",
    searchUsers: "Buscar por nombre, email o teléfono...",
    cancellationType: "Tipo de Cancelación *",
    selectCancellation: "Selecciona un tipo de cancelación",
    cancelVacation: "Cancelación de Turno por vacaciones",
    cancelDate: "Cancelación de Turno por fecha",
    dateFrom: "Fecha desde *",
    dateTo: "Fecha hasta *",
    date: "Fecha *",
    messagePreview: "Vista Previa del Mensaje",
    emailPreview: "Vista Previa del Email",
    subjectLabel: "Asunto:",
    messageLabel: "Mensaje:",
    loadMessagesError: "Error al cargar mensajes",
    loadMessagesErrorDetail: "Error al cargar los mensajes recibidos",
    markReadError: "Error al marcar como leído",
    sendMessagesError: "Error al enviar mensajes",
  },
  billing: {
    configureAfip: "Debe configurar AFIP antes de emitir facturas",
    invoiceCreated: "Factura creada exitosamente",
    invoiceError: "Error al crear la factura",
    pdfError: "Error al generar el PDF",
    downloadError: "Error al descargar el PDF",
    discardError: "Error al descartar el turno",
    issuerData: "Datos del Emisor",
    clientData: "Datos del Cliente",
    totals: "Totales",
    afipInfo: "Información AFIP",
    title: "Facturación",
    subtitle: "Gestione sus facturas electrónicas",
    searchPlaceholder: "Paciente, número...",
    status: "Estado",
    all: "Todos",
    pending: "Pendientes",
    authorized: "Autorizadas",
    rejected: "Rechazadas",
    from: "Desde",
    to: "Hasta",
    noInvoices: "No hay facturas emitidas",
    patient: "Paciente:",
    date: "Fecha:",
    time: "Horario:",
    type: "Tipo:",
    invoiceType: "Tipo de Factura",
    invoiceC: "Factura C (Exento)",
    docType: "Tipo Documento",
    passport: "Pasaporte",
    docNumber: "Número Documento",
    subtotal: "Subtotal",
    total: "Total",
    concept: "Concepto",
    invoiceDetail: "Detalle de Factura",
    invoiceDetailHint: "Información completa de la factura emitida",
    professional: "Profesional:",
    businessName: "Razón Social:",
    salesPoint: "Punto de Venta:",
    document: "Documento:",
    invoiceTypeLabel: "Tipo de Factura:",
    caeExpiry: "Vencimiento CAE:",
    confirmDiscard: "¿Está seguro de que desea descartar este turno? No podrá facturarlo y dejará de aparecer en el listado.",
    notConfigured: "No configurado",
  },
  consent: {
    myDocuments: "Mis documentos ({{count}})",
    docNotFound: "Documento no encontrado",
    loadError: "Error al cargar el documento",
    deleteError: "Error al eliminar el documento",
    deleteSuccess: "Documento eliminado exitosamente",
    titleContentRequired: "Por favor completa el título y contenido del documento",
    authRequired: "Debes estar autenticado para guardar documentos",
    userNotFound: "Error: No se pudo identificar al usuario. Inicia sesión nuevamente.",
    userNotInSystem: "Error: El usuario no existe en el sistema. Contacta al administrador.",
    updateError: "Error al actualizar el documento",
    updateSuccess: "Documento actualizado exitosamente",
    createError: "Error al crear el documento: {{message}}",
    saveSuccess: "Documento guardado exitosamente",
    saveError: "Error al guardar el documento",
    previewRequired: "Por favor completa el título y contenido antes de la vista previa",
    editorTitle: "Editor de Documento",
    viewTitle: "Vista del Documento",
    docTitle: "Título del Documento",
    docTitlePlaceholder: "Ej: Consentimiento para Cirugía de Rodilla",
    docContent: "Contenido del Documento",
    docContentPlaceholder: "Escribe aquí el contenido del documento de consentimiento...",
    confirmDelete: "¿Estás seguro de que quieres eliminar este documento?",
    confirmDeleteCustom: "¿Estás seguro de que quieres eliminar este documento personalizado?",
    confirmCancel: "¿Desea cancelar la operación?",
    totalDocs: "Documentos Totales",
    categories: "Categorías",
    results: "Resultados",
    format: "Formato",
    searchDocs: "Buscar documentos por nombre, categoría o descripción...",
    aboutDocs: "Sobre los Documentos",
    recommendedUse: "Uso Recomendado",
    loading: "Cargando documento...",
    helpPdf: "Todos los documentos están en formato PDF",
    helpBeforeProcedure: "Deben ser completados antes de cada procedimiento",
    helpAskDoctor: "Consultar dudas con el profesional médico",
    helpSignWithDoctor: "Completar y firmar en presencia del médico",
    helpReadFully: "Es importante leer completamente antes de firmar",
    helpReadCarefully: "Leer detenidamente toda la información",
    officialHealthDocs: "Son documentos oficiales del sistema de salud argentino",
    downloadForProcedure: "Descargar el documento correspondiente al procedimiento",
    importantInfoTitle: "Información Importante",
    createdOn: "Documento creado el:",
    pageTitle: "Consentimiento Informado",
    pageSubtitle:
      "Documentos oficiales de consentimiento informado para diferentes procedimientos médicos",
    allCategories: "Todas las categorías",
    createCustomDoc: "Crear Documento Personalizado",
    clearFilters: "Limpiar filtros",
    documentsFoundOne: "{{count}} documento encontrado",
    documentsFoundMany: "{{count}} documentos encontrados",
    resultsForSearch: ' para "{{term}}"',
    resultsInCategory: ' en la categoría "{{category}}"',
    noCustomDocs: "No tienes documentos personalizados",
    noDocsFound: "No se encontraron documentos",
    noCustomDocsHint:
      "Aún no has creado ningún documento de consentimiento personalizado.",
    adjustFiltersHint:
      "Intenta ajustar tus filtros de búsqueda o buscar con otros términos.",
    createFirstDoc: "Crear Primer Documento",
    downloadDocument: "Descargar Documento",
    customDocSubtitle: "Documento de consentimiento personalizado",
    backToDocs: "Volver a Documentos",
    editConsentTitle: "Editar Documento de Consentimiento",
    createConsentTitle: "Crear Documento de Consentimiento",
    editConsentSubtitle: "Edita el documento de consentimiento informado",
    createConsentSubtitle:
      "Crea un documento de consentimiento informado personalizado",
    saving: "Guardando...",
    updateDocument: "Actualizar Documento",
    saveDocument: "Guardar Documento",
    preview: "Vista Previa",
    edit: "Editar",
    cancel: "Cancelar",
    printDocument: "Imprimir Documento",
    downloadPdf: "Descargar PDF",
    delete: "Eliminar",
    loadingEditor: "Cargando editor...",
    previewSection: "Vista previa del documento",
    quill: {
      bold: "Negrita",
      italic: "Cursiva",
      underline: "Subrayado",
      strike: "Tachado",
      orderedList: "Lista numerada",
      bulletList: "Lista con viñetas",
      indentLess: "Disminuir sangría",
      indentMore: "Aumentar sangría",
      link: "Enlace",
      image: "Imagen",
      clean: "Limpiar formato",
      header: "Estilo de texto",
      headerNormal: "Normal",
      headerH1: "Título 1",
      headerH2: "Título 2",
      headerH3: "Título 3",
      headerH4: "Título 4",
      headerH5: "Título 5",
      headerH6: "Título 6",
      align: "Alineación",
      alignLeft: "Izquierda",
      alignCenter: "Centro",
      alignRight: "Derecha",
      alignJustify: "Justificado",
      uploadImageError: "Error al subir la imagen",
    },
    categoryLabels: {
      anesthesia: "Anestesia",
      diagnostic: "Diagnóstico",
      ophthalmology: "Oftalmología",
      vascularSurgery: "Cirugía Vascular",
      general: "General",
      surgery: "Cirugía",
      hemotherapy: "Hemoterapia",
      rehabilitation: "Rehabilitación",
      cardiology: "Cardiología",
      custom: "Personalizado",
    },
    predefined: {
      anesthesiaPostop: {
        title: "Anestesia y Analgesia Postoperatoria",
        description:
          "Consentimiento para procedimientos anestésicos y manejo del dolor postoperatorio",
      },
      bronchoscopy: {
        title: "Broncoscopía",
        description:
          "Procedimiento endoscópico para examinar las vías respiratorias",
      },
      cataractSurgery: {
        title: "Cirugía de Cataratas",
        description: "Intervención quirúrgica para el tratamiento de cataratas",
      },
      crosectomy: {
        title: "Crosectomía",
        description: "Procedimiento quirúrgico vascular",
      },
      diagnosisTreatment: {
        title: "Diagnóstico y/o Tratamiento",
        description:
          "Consentimiento general para procedimientos diagnósticos y terapéuticos",
      },
      electromyogram: {
        title: "Electromiograma",
        description: "Estudio de la actividad eléctrica muscular",
      },
      limbAmputation: {
        title: "Intervención Quirúrgica de Amputación de Miembros",
        description: "Procedimiento quirúrgico de amputación",
      },
      hivTest: {
        title: "Prueba Diagnóstica de H.I.V",
        description: "Consentimiento para prueba de detección de VIH",
      },
      bloodTransfusion: {
        title: "Práctica Transfusional",
        description: "Consentimiento para transfusión sanguínea",
      },
      cardioRehab: {
        title: "Programa de Rehabilitación Cardiorrespiratoria",
        description: "Programa de rehabilitación cardiovascular y respiratoria",
      },
      stressTest: {
        title: "Prueba de Ergometría Graduada",
        description: "Prueba de esfuerzo cardiovascular",
      },
      liverBiopsy: {
        title: "Punción Biopsia Hepática",
        description: "Procedimiento de biopsia hepática",
      },
    },
  },
  search: {
    sortDistance: "Ubicación (más cerca)",
    insurance: "Obra social / Prepaga",
    allInsurances: "Todas",
    myInsurance: "{{name}} (tu cobertura)",
    acceptsInsurance: "Atiende por tu cobertura",
    notAcceptsInsurance: "No atiende por tu cobertura: solo turnos particulares",
    addInsurance: "Debes agregar tu cobertura médica",
    noDoctorAddress: "El profesional no suministró su dirección",
    distanceAt: "A {{km}} km, en {{address}}",
    addAddress: "Debes agregar tu dirección para ver la distancia",
    title: "Búsqueda",
    searchAssociation: "Buscar por nombre de asociación...",
    searchProfessional: "Buscar por nombre, apellido, especialidad o email...",
    searchDoctor: "Buscar médico por nombre, apellido, especialidad...",
    searchProfessionalShort: "Buscar profesional...",
    searchAssociationLabel: "Buscar Asociación",
    sortName: "Nombre",
    specialty: "Especialidad",
    allSpecialties: "Todas las especialidades",
    institution: "Institución",
    allInstitutions: "Todas las instituciones",
    perConsultation: "por consulta",
    pageTitle: "Buscar Profesional",
    pageSubtitle: "Encuentra el médico ideal para tu consulta",
    filters: "Filtros",
    clearFilters: "Limpiar filtros",
    sortBy: "Ordenar por:",
    hasPrivateSchedule: "Tiene agenda particular",
    memberSince: "Miembro desde {{year}}",
    scheduleAtInstitution: "Tiene agenda en {{name}}",
    bookAppointment: "Reservar Turno",
    professionalsFoundOne: "{{count}} profesional encontrado",
    professionalsFoundMany: "{{count}} profesionales encontrados",
    resultsForSearch: ' para "{{term}}"',
    patientsOnly: "Esta sección es solo para pacientes.",
    noProfessionalsFound: "No se encontraron profesionales",
    adjustFiltersHint:
      "Intenta ajustar tus filtros de búsqueda o buscar con otros términos.",
    specializations: {
      cardiology: "Cardiología",
      dermatology: "Dermatología",
      endocrinology: "Endocrinología",
      gastroenterology: "Gastroenterología",
      gynecology: "Ginecología",
      generalMedicine: "Medicina General",
      neurology: "Neurología",
      ophthalmology: "Oftalmología",
      orthopedics: "Ortopedia",
      pediatrics: "Pediatría",
      psychiatry: "Psiquiatría",
      traumatology: "Traumatología",
      urology: "Urología",
    },
  },
  secretary: {
    searchDoctor: "Buscar médico por nombre, apellido, especialidad...",
    totalAssigned: "Total Asignados",
    searchPatientEmail: "Buscar Paciente por Email",
    patientName: "Nombre del Paciente *",
    searchEmailPlaceholder: "Ingresa email o parte del email",
    patientEmailPlaceholder: "Email del paciente",
    patientNamePlaceholder: "Nombre completo del paciente",
    availableDoctors: "Médicos Disponibles",
    sharedSchedules: "Horarios Compartidos",
    specialties: "Especialidades",
    assign: "Asignar",
    overbooking: "Sobreturno",
    limitations: "Limitaciones",
    manageAppointments: "Gestionar turnos para pacientes",
    whatYouCanDo: "¿Qué puedes hacer?",
    viewSharedSchedules: "Ver los horarios que los médicos han compartido contigo",
    assignFromSlots:
      "Asignar turnos desde slots disponibles o sobreturnos en horarios ya ocupados",
    viewRealtimeAvailability: "Ver la disponibilidad en tiempo real",
    onlySharedWithYou:
      "Solo puedes ver horarios compartidos específicamente contigo",
    cannotSeePrivate:
      "No puedes ver turnos particulares o de obra social existentes",
    cannotModifySchedules: "No puedes modificar los horarios del médico",
    overbookingHint:
      "En turnos ocupados podés ir a asignar un sobreturno desde el botón correspondiente",
    assignOverbookingTitle: "Asignar sobreturno en este horario",
  },
  commonUi: {
    error: "Error",
    search: "Búsqueda",
    importantInfo: "Información Importante",
    sending: "Enviando...",
    sendInstructions: "Enviar instrucciones",
    searching: "Buscando...",
    searchPlaceholder: "Buscador...",
    add: "Agregar",
  },
  insurance: {
    groupPrepaid: "Prepagas",
    groupSocial: "Obras sociales",
    none: "Sin cobertura / Seleccionar",
    other: "Otra (no está en el listado)",
    otherPlaceholder: "Escribí el nombre de tu cobertura",
    remove: "Quitar {{name}}",
    noneSelected:
      "Todavía no elegiste coberturas: los pacientes solo verán tus turnos particulares.",
    searchPlaceholder: "Buscar obra social o prepaga...",
    acceptedTitle: "Obras sociales y prepagas que atendés",
    acceptedHint:
      "Los pacientes verán en la búsqueda si atendés su cobertura. Si no la atendés, solo podrán reservar tus turnos particulares.",
  },
  booking: {
    loadingDoctors: "Cargando médicos...",
    doctorNotFound: "Médico no encontrado",
    selectedSlot: "Turno Seleccionado:",
    fullName: "Nombre Completo *",
    fullNamePlaceholder: "Ingresa tu nombre completo",
    phone: "Teléfono",
    countryCode: "Código",
    phonePlaceholder: "Ej: 11 1234-5678",
    reason: "Motivo *",
    reasonPlaceholder: "Motivo de consulta, observaciones, etc.",
    bookingFor: "¿Para quién es el turno?",
    forMyself: "Para mí",
    privateOnlyInsurance:
      "Este profesional no atiende por {{insurance}}: solo se muestran los días y horarios en que atiende particular.",
    privateOnlyNoInsurance:
      "No tenés una cobertura médica cargada: solo se muestran los días y horarios en que el profesional atiende particular.",
  },
  dependents: {
    title: "Familiares",
    intro:
      "Registrá a tus hijos o familiares para poder sacarles turnos en su nombre.",
    add: "Agregar familiar",
    addTitle: "Agregar familiar",
    editTitle: "Editar familiar",
    name: "Nombre *",
    lastName: "Apellido *",
    dni: "DNI",
    birthDate: "Fecha de nacimiento",
    relationship: "Vínculo",
    relSelect: "Seleccionar…",
    relChild: "Hijo/a",
    relSpouse: "Cónyuge",
    relParent: "Madre/Padre",
    relSibling: "Hermano/a",
    relOther: "Otro",
    healthInsurance: "Obra social",
    healthInsuranceNumber: "N° de afiliado",
    created: "Familiar agregado",
    updated: "Familiar actualizado",
    saveError: "Error al guardar el familiar",
    deleted: "Familiar eliminado",
    deleteError: "Error al eliminar",
    deleteTitle: "Eliminar familiar",
    deleteConfirm:
      "¿Estás seguro que deseas eliminar a {{name}}? Sus turnos ya reservados no se cancelan automáticamente.",
    delete: "Eliminar",
    deleting: "Eliminando…",
    loadError: "No se pudieron cargar los familiares.",
    emptyState:
      "Todavía no agregaste familiares. Usá el botón de arriba para agregar el primero.",
  },
  acting: {
    operatingWith: "Operar con",
    myself: "Yo",
    myselfCaption: "Titular de la cuenta",
    title: "¿Con quién querés operar?",
    addAndSelect: "Se agregará y quedará seleccionado para operar.",
  },
  waitingRoom: {
    title: "Recepción de Pacientes",
    subtitleDoctor: "Pacientes presentes en recepción — Dr. {{name}} {{lastName}}",
    subtitleSecretary: "Gestión de llegada de pacientes — {{name}} {{lastName}}",
    patientsInReception: "Pacientes en recepción",
    dailyAppointments: "Turnos del Día",
    inWaitingRoom: "En recepción",
    inReceptionBadge: "En recepción",
    markPresent: "Marcar presente",
    present: "Presente",
    private: "Particulares",
    firstAppointment: "Primer Turno",
    search: "Buscar por paciente, doctor o horario...",
    doctor: "Doctor:",
    nextAppointment: "Próximo Turno",
    patientsWaiting: "Pacientes Esperando",
    emptyNoPatients: "No hay pacientes en recepción",
    emptyNoPatientsHint:
      "Los pacientes aparecerán aquí cuando la secretaria los marque como presentes",
  },
  studies: {
    commentPlaceholder: "Ej.: Resonancia lumbar abril 2026, solicitada por traumatología…",
    uploaded: "Subida:",
    comment: "Comentario",
    confirmDelete: "¿Eliminar este estudio? La imagen dejará de mostrarse en tu perfil.",
    saveError: "Error al guardar el estudio",
    updateError: "Error al actualizar",
    deleteError: "Error al eliminar",
    uploadError: "Error al subir la imagen",
    pageIntro:
      "Subí fotos o capturas de tus estudios médicos y agregá una nota para recordar el contexto. Las imágenes se almacenan de forma segura mediante imgBB.",
    uploadTitle: "Subir nuevo estudio",
    imageLabel: "Imagen",
    chooseFile: "Elegir archivo",
    previewAlt: "Vista previa",
    commentOptional: "Comentario (opcional)",
    uploading: "Subiendo…",
    saveStudy: "Guardar estudio",
    loadError:
      "No se pudieron cargar tus estudios. Si el problema continúa, contactá soporte.",
    emptyState:
      "Todavía no cargaste estudios. Usá el formulario de arriba para agregar el primero.",
    yourStudies: "Tus estudios ({{count}})",
    studyAlt: "Estudio",
    savingComment: "Guardando…",
    saveComment: "Guardar comentario",
    delete: "Eliminar",
  },
  users: {
    confirmDelete: "¿Seguro desea eliminar este usuario?",
    copied: "Copiado!",
    title: "Usuarios",
    viewDetail: "Ver detalle",
    copyInvite: "Copiar Invitacion",
    edit: "Editar",
    delete: "Eliminar",
  },
  payments: {
    title: "Detalles del pago",
    successTitle: "¡Pago Exitoso!",
    successBody: "Tu pago se ha completado exitosamente. Gracias por tu compra. Si tienes alguna pregunta, no dudes en contactarnos.",
    pendingTitle: "¡Pago pendiente!",
    pendingBody: "Tu pago está en proceso. Por favor, espera mientras confirmamos tu transacción. Si el pago no se completa en breve, intenta nuevamente o contacta al soporte.",
    failureTitle: "¡Pago fallido!",
    failureBody: "Tu pago no se ha completado. Por favor, intenta nuevamente o contacta al soporte si el problema persiste.",
    supportHint: "Si necesitas ayuda, por favor contacta a nuestro equipo de soporte.",
    payWithMp: "Pagar con MercadoPago",
    mpRequestError: "Error en la petición",
    mpPaymentUrlError: "No se pudo obtener la URL de pago",
    mpProcessError: "Ocurrió un error al procesar el pago. Por favor intenta nuevamente.",
    sampleProduct: "Producto de ejemplo",
    paymentFormTitle: "Detalles del pago",
    paymentFormHint: "Ingresa los detalles para proceder con el pago",
  },
  subscriptionSuccess: {
    title: "¡Suscripción Creada Exitosamente!",
    body: "Tu suscripción ha sido configurada correctamente. Los pagos se realizarán automáticamente según tu ciclo de facturación.",
    hint: "Puedes gestionar tu suscripción desde tu perfil en cualquier momento.",
    viewSubscription: "Ver Mi Suscripción",
    goHome: "Ir al Inicio",
  },
  invite: {
    title: "Invitacion",
    enterPassword: "Ingrese una clave",
    required: "* Obligatorio",
    setPassword: "Establecer contraseña",
  },
  landing: {
    loadingInstitution: "Cargando información de la institución...",
    loadingAssociation: "Cargando información de la asociación...",
    medicalInstitution: "Institución Médica",
    medicalCenter: "Centro Médico",
    professionalAssociation: "Asociación Profesional",
    memberSince: "Miembro desde",
    associatedProfessionals: "Profesionales asociados",
    subscribed: "Suscrito",
    subscribedProfessionals: "Profesionales suscritos",
  },
  afip: {
    title: "Configuración AFIP",
    subtitle: "Configure sus credenciales para facturación electrónica",
    back: "Volver",
    activeSince: "Configuración activa desde",
    certExpires: "Certificado vence:",
    tabConfig: "Configuración",
    tabInstructions: "Instructivo",
    fiscalData: "Datos Fiscales",
    commercialAddress: "Domicilio Comercial *",
    technicalConfig: "Configuración Técnica",
    businessName: "Razón Social *",
    businessNamePlaceholder: "Dr. Juan Pérez",
    vatCondition: "Condición IVA",
    registeredTaxpayer: "Responsable Inscripto",
    monotax: "Monotributista",
    exempt: "Exento",
    addressPlaceholder: "Av. Corrientes 1234, CABA",
    salesPoint: "Punto de Venta",
    environment: "Ambiente",
    testingEnv: "Testing (Pruebas)",
    production: "Producción",
    certExpiry: "Vencimiento Certificado *",
    productionWarning:
      "Modo producción: Las facturas serán reales y reportadas a AFIP",
    certificatesTitle: "Certificados AFIP",
    certificatesDesc:
      "Suba sus certificados obtenidos desde AFIP. Los archivos se almacenan de forma segura y encriptada.",
    certificateLabel: "Certificado (.crt o .pem) *",
    privateKeyLabel: "Clave Privada (.key o .pem) *",
    certificateConfigured: "Certificado configurado",
    privateKeyConfigured: "Clave privada configurada",
    certificatesStorageNote:
      "Los certificados se almacenan encriptados en la base de datos. Solo suba archivos nuevos si necesita actualizarlos.",
    saving: "Guardando...",
    updateConfig: "Actualizar Configuración",
    saveConfig: "Guardar Configuración",
    testConnection: "Probar Conexión",
    fileExtension: "Archivo debe tener extensión {{extensions}}",
    extensionOr: " o ",
    fileTooLarge: "El archivo no puede superar 1MB",
    cuitInvalid: "CUIT debe tener 11 dígitos",
    businessNameRequired: "Razón social es requerida",
    addressRequired: "Domicilio comercial es requerido",
    certificateRequired: "Certificado es requerido",
    privateKeyRequired: "Clave privada es requerida",
    expiryRequired: "Fecha de vencimiento es requerida",
    saveSuccess: "Configuración de AFIP guardada exitosamente",
    saveError: "Error al guardar la configuración. Intente nuevamente.",
    saveBeforeTest: "Debe guardar la configuración antes de probar la conexión",
    connectionSuccess: "Conexión con AFIP exitosa",
    connectionError: "Error al conectar con AFIP",
    testConnectionError: "Error al probar la conexión",
    instructionsTitle: "Cómo obtener certificados de AFIP",
    instructionsDesc:
      "Siga estos pasos para obtener sus certificados de facturación electrónica",
    step1Title: "Paso 1: Acceder a AFIP",
    step1Intro: "Ingrese a",
    step1WithCredentials: "con su CUIT y Clave Fiscal",
    step2Title: "Paso 2: Administrador de Relaciones de Clave Fiscal",
    step2Body:
      'Vaya a "Administrador de Relaciones de Clave Fiscal" → "Certificados Digitales"',
    step3Title: "Paso 3: Generar Certificado",
    step3Item1: 'Seleccione "Generar nuevo certificado"',
    step3Item2: 'Elija "Certificado para aplicaciones"',
    step3Item3: "Complete los datos solicitados",
    step3Item4: "Descargue el archivo .p12",
    step4Title: "Paso 4: Convertir certificado",
    step4Body:
      "Use OpenSSL para convertir el archivo .p12 a los formatos requeridos:",
    step4CommandCert: "# Extraer certificado (.crt)",
    step4CommandKey: "# Extraer clave privada (.key)",
    step5Title: "Paso 5: Configurar en la aplicación",
    step5Item1: "Suba el archivo certificado.crt",
    step5Item2: "Suba el archivo clave_privada.key",
    step5Item3: "Complete los datos fiscales",
    step5Item4: "Pruebe la conexión",
    keepCertsSafe:
      "Mantenga sus certificados seguros y no los comparta. La aplicación los almacena de forma encriptada para su seguridad.",
    requiredServicesTitle: "Servicios requeridos en AFIP",
    requiredServicesIntro:
      "Asegúrese de tener habilitados los siguientes servicios en AFIP:",
    requiredService1: "Comprobantes en Línea - Factura Electrónica",
    requiredService2: "Web Service de Facturación Electrónica",
    requiredService3: "Autenticación y Autorización de Servicios Web",
  },
};
